import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowWizard } from '@/features/workflows/workflow-wizard';

export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/new')({
  component: NewWorkflowRoute,
});

function NewWorkflowRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[{ label: t('nav.items.workflows') }, { label: t('workflows.newTitle') }]}
    >
      <WorkflowWizard tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
